export enum TimeUnit {
    MINUTE = 'min',
    HOUR = 'h',
    DAY = 'd',
    MONTH = 'm'
  }